






import { defineComponent } from '@vue/composition-api';
import { ParagraphSize } from './enums/paragraph-size';

export default defineComponent({
  name: 'BaseParagraph',
  props: {
    size: {
      type: String,
      default: ParagraphSize.Medium,
    },
  },
});
